let ctx: AudioContext | null = null;
let unlocked = false;

function getCtx(): AudioContext {
  if (!ctx) ctx = new AudioContext();
  return ctx;
}

export function unlockAudio(): void {
  if (unlocked) return;
  const c = getCtx();
  if (c.state === 'suspended') void c.resume();
  unlocked = true;
}

function noiseBuffer(durationSec: number): AudioBuffer {
  const c = getCtx();
  const len = Math.floor(c.sampleRate * durationSec);
  const buf = c.createBuffer(1, len, c.sampleRate);
  const data = buf.getChannelData(0);
  for (let i = 0; i < len; i++) data[i] = Math.random() * 2 - 1;
  return buf;
}

function tick(freqHz: number, gainPeak: number, durationSec: number, q = 0.7) {
  const c = getCtx();
  const now = c.currentTime;
  const src = c.createBufferSource();
  src.buffer = noiseBuffer(durationSec);
  const filt = c.createBiquadFilter();
  filt.type = 'bandpass';
  filt.Q.value = q;
  filt.frequency.value = freqHz;
  const gain = c.createGain();
  gain.gain.setValueAtTime(0.0, now);
  gain.gain.linearRampToValueAtTime(gainPeak, now + 0.0015);
  gain.gain.exponentialRampToValueAtTime(0.001, now + durationSec);
  src.connect(filt).connect(gain).connect(c.destination);
  src.start(now);
}

/** A tile being selected — short bone-clack click. */
export function playSelect(): void {
  if (!unlocked) return;
  tick(2200, 0.025, 0.04, 1.2);
}

/** A pair being matched and removed — slightly fuller. */
export function playMatch(): void {
  if (!unlocked) return;
  tick(1800, 0.03, 0.06, 1.0);
  setTimeout(() => tick(1300, 0.022, 0.07, 0.8), 35);
}

/** Tiles being dealt at game start. */
export function playShuffle(): void {
  if (!unlocked) return;
  for (let i = 0; i < 6; i++) {
    setTimeout(() => tick(1900 + Math.random() * 600, 0.012, 0.03), i * 70 + Math.random() * 30);
  }
}

/** Invalid pair attempted — soft bonk. */
export function playInvalid(): void {
  if (!unlocked) return;
  tick(380, 0.02, 0.09, 0.5);
}
